var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("CabeceraModalEditarBase", {
        attrs: {
          titulo: _vm.titulo,
          tituloEliminar: _vm.nombreEntidad
            ? _vm.$t("mensajes.crud.editar.titulo", {
                entidad: _vm.entidad,
                nombreEntidad: _vm.nombreEntidad
              })
            : _vm.$t("mensajes.crud.editar.tituloSinNombre", {
                entidad: _vm.entidad
              }),
          entidad: _vm.entidad,
          pasos: _vm.pasos,
          pasoActivoIndex: _vm.pasoActivoIndex,
          inactivable: _vm.inactivable,
          estadoEntidad: _vm.estadoEntidad,
          inactivoSinAsociacion: _vm.inactivoSinAsociacion,
          form: _vm.form,
          pronombre: _vm.pronombre,
          mensajeInactivo: _vm.mensajeInactivo
        },
        on: {
          cerrar: _vm.handleCerrar,
          guardar: _vm.handleGuardar,
          inactivo: _vm.handleInactivo
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }